/* eslint-disable */
export const CREATE_USER_PROFILE = `CREATE_USER_PROFILE`;
export const UPDATE_USER_PROFILE = `UPDATE_USER_PROFILE`;
